module.exports = __webpack_public_path__ + "img/christmascouple.d034aac5.svg";